import Component from "@ember/component"
import { inject as service } from "@ember/service"
import hasMany from "cc-frontend/helpers/has-many-collectively"

export default class AdminDetailAction extends Component {
  @service("ember-store") store
  @hasMany("modelToStringify.content", "patch", "patches") patches
}
